import React from 'react';
import { CircularProgress, Box, Grid, Typography } from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';
import { EquipmentCostsContext } from '../contexts/EquipmentCostsContext';
import EquipmentCostForm from '../components/EquipmentCostForm';

const CostProfileNew: React.FunctionComponent = () => {
  const { costProfileId } = useParams<Record<string, string>>();
  const history = useHistory();
  const [costProfileFetched, setCostProfileFetched] = React.useState(false);
  const { fetchEquipmentCost, costProfile, costProfileLoading } = React.useContext(EquipmentCostsContext);

  React.useEffect(() => {
    if (!costProfileFetched) {
      setCostProfileFetched(true);
    }
  }, [costProfileFetched, setCostProfileFetched, fetchEquipmentCost, costProfileId]);

  return (
    <>
      <Typography
        style={{ marginBottom: 10, color: '#333', opacity: 0.6, cursor: 'pointer' }}
        onClick={() => history.push('/equipment_costs')}
      >
        ← Return to Equipment Costs
      </Typography>
      <Typography variant="h5" component="h5">
        New Equipment Cost Details
      </Typography>
      <Grid container flex-direction="column">
        <Grid item xs={10}>
          <EquipmentCostForm costProfile={{}} onSuccess={() => history.push('/equipment_costs')} />
        </Grid>
      </Grid>
    </>
  );
};

export default CostProfileNew;
